export default "__VITE_ASSET__TWydrSR$__"